<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <!--    <router-view></router-view>-->
    <SecondProductClassify/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import SecondProductClassify from "@/views/business/product/secondProductClassify.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    SecondProductClassify,
    Footer
  },
}
</script>

<style>
</style>